import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
const TOKEN_KEY = 'auth-token';
const USER_KEY = 'auth-user';

@Injectable({
  providedIn: 'root'
})

/* para administrar el token y la información del usuario ( correo electrónico, roles) dentro del
 almacenamiento de sesión del navegador. Para cerrar sesión, solo necesitamos borrar este almacenamiento de sesión */

export class TokenStorageService {

  constructor(private http: HttpClient) { }

  signOut(): void {
    window.localStorage.clear();
  }

  public saveToken(token: string): void {
    window.localStorage.removeItem(TOKEN_KEY);
    window.localStorage.setItem(TOKEN_KEY, token);
  }
  //Obtenemos el token de alamacenamiento de session 
  public getToken(): string | null {
    return window.localStorage.getItem(TOKEN_KEY);
  }
  //Guardamos datos de usuario en cliente 
  public saveUser(user: any): void {
    window.localStorage.removeItem(USER_KEY);
    window.localStorage.setItem(USER_KEY, JSON.stringify(user));
  }
  //Obtener datos de usuario en cliente 
  public getUser(): any {
    const user = window.localStorage.getItem(USER_KEY);
    if (user) {
      return JSON.parse(user);
    }
    return {};
  }

  isLogged(): boolean {
    const user = JSON.parse(window.localStorage.getItem(USER_KEY));

    if (this.getToken() && user.idteam === 1) {
      return true;
    }
    return false
  }

  isLoggedSurvey(): boolean {
    const user = JSON.parse(window.localStorage.getItem(USER_KEY));

    if (this.getToken() && user.idteam === 1 && user.isAllowed) {
      return true;
    }
    return false
  }

  
  isAdminLogged(): boolean {
    const user = JSON.parse(window.localStorage.getItem(USER_KEY));

    if (this.getToken() && user.id === 2) {
      return true;
    }
    return false
  }

}
